import breakpoints from '../../styles/01-variables/breakpoint.module.scss';

/** Breakpoints (px) */
const Breakpoints = Object.fromEntries(
    Object.entries(breakpoints).map(([key, value]) => [key, Number(value)])
);

export default Breakpoints;
